module.exports = __webpack_public_path__ + "static/EnmTX_BosGodastrology_L_A_cl-f70c60b24e98b7804ae97dfc2d09a77a.gif";